/** The assignee pair, and how it goes onto the wire.
 *
 * Separate from `AssigneePicker.tsx` so that file exports only its component — a mixed
 * module breaks Vite's fast refresh, and the picker is edited often enough for that to
 * matter.
 */

/** An id and the matching display name. Both halves travel together. */
export interface AssigneeValue {
  userId: string
  /** The display name. Kept in step with `userId`, and all there is for an unlinked name. */
  name: string
}

/**
 * The two fields to send on a create or update.
 *
 * A helper rather than two lines at each call site, so the pair can never be sent half
 * updated — an id pointing at one person beside another person's name is the exact bug
 * the picker exists to prevent.
 */
export function assigneeFields(value: AssigneeValue): {
  assignee_name: string
  assignee_user_id: string | null
} {
  return {
    assignee_name: value.name,
    assignee_user_id: value.userId || null,
  }
}
